var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row mb-4" }, [
        _c(
          "div",
          {
            staticClass:
              "col-sm-10 offset-sm-1 col-md-8 offset-md-2 text-center mb-3"
          },
          [
            _c("form", [
              _c("div", { staticClass: "row" }, [
                _vm.news_categories
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-10 offset-1 col-sm-6 offset-sm-3 col-md-4 offset-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-group mb-0" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.category,
                                  expression: "category"
                                }
                              ],
                              staticClass: "form-control selectpicker",
                              attrs: {
                                id: "news-category",
                                name: "news-category"
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.category = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    _vm.pushHistoryState()
                                    _vm.getNews()
                                    _vm.calculatePagesBefore(
                                      _vm.pagination.current_page
                                    )
                                    _vm.calculatePagesAfter(
                                      _vm.pagination.current_page
                                    )
                                    _vm.goToFirstPage()
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.filter_labels["select_category"])
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.news_categories, function(category) {
                                return _c(
                                  "option",
                                  {
                                    key: category.id,
                                    domProps: { value: category.id }
                                  },
                                  [_vm._v(_vm._s(category.name))]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.news
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-10 offset-1 col-md-8 offset-md-2 px-md-0" },
              _vm._l(_vm.news, function(article) {
                return _c(
                  "div",
                  { key: article.id, staticClass: "row news-pod" },
                  [
                    article.featured_image
                      ? _c("div", { staticClass: "col-12 col-md-4" }, [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: article.featured_image,
                              alt: article.title
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 content",
                        class: { "col-md-8": _vm.hasFeaturedImage(article) }
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "text-primary mb-1 mt-4 mt-md-1" },
                          [_vm._v(_vm._s(article.title))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-grey-dark" }, [
                          article.primary_term
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(article.primary_term + " |")
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(article.post_date) +
                              " | " +
                              _vm._s(article.post_author) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(article.excerpt) }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-right mt-2" }, [
                          _c("a", { attrs: { href: article.permalink } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.filter_labels["read_article"]) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid text-center" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-10 offset-1 mt-2 pt-1 mt-md-2 pt-md-0 pb-4 mb-3",
            attrs: { id: "pagination" }
          },
          [
            _vm.pagination.total_pages > 1
              ? _c(
                  "div",
                  { staticClass: "wp-pagenavi" },
                  [
                    _c("span", { staticClass: "pages" }, [
                      _vm._v(
                        "Page " +
                          _vm._s(_vm.pagination.current_page) +
                          " of " +
                          _vm._s(_vm.pagination.total_pages)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.pagination.current_page > 2
                      ? _c(
                          "a",
                          {
                            staticClass: "first",
                            attrs: {
                              href:
                                _vm.pagination.base_url +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-double-left" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pagination.current_page > 1
                      ? _c(
                          "a",
                          {
                            staticClass: "previouspostslink",
                            attrs: {
                              rel: "prev",
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                (parseInt(_vm.pagination.current_page) - 1) +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-left" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.pagesBefore, function(page) {
                      return _c(
                        "a",
                        {
                          key: page,
                          staticClass: "page smaller",
                          attrs: {
                            title: "Page " + page,
                            href:
                              _vm.pagination.base_url +
                              "page/" +
                              page +
                              "?category=" +
                              _vm.category
                          }
                        },
                        [
                          _vm._v(
                            "\n              " + _vm._s(page) + "\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "current" }, [
                      _vm._v(_vm._s(_vm.pagination.current_page))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.pagesAfter, function(page) {
                      return _c(
                        "a",
                        {
                          key: page,
                          staticClass: "page smaller",
                          attrs: {
                            title: "Page " + page,
                            href:
                              _vm.pagination.base_url +
                              "page/" +
                              page +
                              "?category=" +
                              _vm.category
                          }
                        },
                        [
                          _vm._v(
                            "\n              " + _vm._s(page) + "\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.pagination.current_page < _vm.pagination.total_pages
                      ? _c(
                          "a",
                          {
                            staticClass: "nextpostslink",
                            attrs: {
                              rel: "next",
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                (parseInt(_vm.pagination.current_page) + 1) +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-right" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pagination.current_page < _vm.pagination.total_pages - 1
                      ? _c(
                          "a",
                          {
                            staticClass: "last",
                            attrs: {
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                _vm.pagination.total_pages +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-double-right" })]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib?{}!./scripts/vue/news.vue?vue&type=template&id=6f695832&
// module id = 87
// module chunks = 0